import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    width: 100,
    fieldName: '数量'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTypeName',
    fieldName: '维修类型'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'typeName',
    width: 100,
    fieldName: '业务类型'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    width: 100,
    fieldName: '业务分类'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'urgentName',
    width: 80,
    fieldName: '紧急程度'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesManName',
    width: 100,
    fieldName: '业务员'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'engineerName',
    width: 100,
    fieldName: '工程师'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'assignTime',
    fieldName: '分配时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairStartTime',
    fieldName: '开始时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expectedCompletedTime',
    fieldName: '预计完成'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'actualCompletedTime',
    fieldName: '完成时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expectedCompletedDays',
    fieldName: '预计天数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overtime',
    fieldName: '是否超时',
    convert: context => {
      const { rowData } = context
      if (undefined === rowData.overtime || rowData.overtime == null) {
        return ''
      }
      return rowData.overtime ? '是' : '否'
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTimes',
    width: 100,
    fieldName: '返修次数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'statusMark',
    width: 100,
    fieldName: '业务状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'completed',
    width: 100,
    fieldName: '是否完成'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fault',
    fieldName: '故障描述'
  }
]
